import React, {useState} from 'react'
import {useSelector} from "react-redux";
import {Col, Row} from "reactstrap";


// components
import {getStateByPath} from "../../../../redux/selectors";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

// services
import {pageLabelService} from "../../../../jwt/_services/landings/pageLabelService";

// providers
import {labelProvider} from "../../../../providers/configuration/labelProvier";

const LinkedLabels = props => {
    const path = `${props.path}/labels`;

    const pageState = useSelector(state => getStateByPath(state, props.path));
    const {app, domainObject: page} = pageState?.data || {};
    const {fbDataBase} = app

    const [label, setLabel] = useState(null)

    const handleLinkAmenity = () => {
        if(!label) return;

        const requestData = {
            fbDataBase,
            item:{
                page: {id: page?.id},
                label: {id: label}
            }
        }

        genericIndexedActions.save(path, pageLabelService, requestData, resetLabel)
    }

    const resetLabel = () => setLabel(null)


    return <Row className={'mb-2em'}>
        <Col sm={9}>
            <SelectGeneric
                title={'Etiqueta'}
                showSpinner={false}
                initialValue={label}
                setExternalValue={setLabel}
                provider={labelProvider}
            />
        </Col>
        <Col>
            <div className={'pt-2em pull-left'}>
                <GenericButton
                    clazz={'mt-2em'}
                    style={'table'}
                    label={'Vincular'}
                    toolTip={'Agregar Actividad'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={handleLinkAmenity}
                />
            </div>
        </Col>
    </Row>
}
export default LinkedLabels;